// extracted by mini-css-extract-plugin
module.exports =  {"collapseRow":"collapseRow__gUx1q"};